import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-input" }
const _hoisted_2 = { class: "label-input" }
const _hoisted_3 = ["value", "min"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("input", {
      type: "date",
      class: "input",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeInput && _ctx.changeInput(...args))),
      value: _ctx.value,
      autocomplete: "off",
      min: _ctx.min
    }, null, 40, _hoisted_3),
    _createElementVNode("p", {
      class: _normalizeClass([_ctx.hasError ? 'error' : 'no-error'])
    }, _toDisplayString(_ctx.error?.esMessage || ""), 3),
    _createElementVNode("p", null, _toDisplayString(_ctx.min), 1)
  ]))
}